
import * as cloudflareRuntime$_uLNKE1ozkoBFadG0fVu5Ggw4rUBYOm5tHvMWdQaVro from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as noneRuntime$xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing": {
      "modifiers": {
        "height": 227,
        "fit": "fill",
        "format": "webp"
      }
    }
  },
  "provider": "none",
  "domains": [
    "zebrafashion.s3.eu-central-1.amazonaws.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$_uLNKE1ozkoBFadG0fVu5Ggw4rUBYOm5tHvMWdQaVro, defaults: {"baseURL":"https://stage-zebra.go2flow.com/"} },
  ['none']: { provider: noneRuntime$xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU, defaults: {} }
}
        